import React, { ReactElement, useContext } from 'react'
import EntryMetadata from './EntryMetadata'
import EntryTitleLine from './EntryTitleLine'
import EntryContentText from './EntryContentText'
import { EntryContext } from '../contexts/EntryContext'
import { useNavigate } from 'react-router-dom'
import ErrorMessage from '../common/ErrorMessage'
import { AppContext } from '../contexts/AppContext'

const EntryThumbnail = (props: { entryId: number }): ReactElement => {
    const { isUserType } = useContext(AppContext)
    const { state } = useContext(EntryContext)
    const navigate = useNavigate()
    const entry = state.write?.[props.entryId] || state.entries?.[props.entryId]
    if (!entry)
        return <ErrorMessage status="Entry not found" />

    const staticOrLink = 'thumbnail-link entry-thumbnail-link'
    return (
        <div
            className={ 'thumbnail entry-thumbnail ' + staticOrLink }
            onClick={ (event) => {
                // eslint-disable-next-line dot-notation
                if (event.target['classList'].contains('entry-thumbnail-link')) {
                    void navigate(`/write?entryId=${props.entryId}`)
                }
            } }>
            { !isUserType('public')
              && <EntryTitleLine className={ staticOrLink } entry={ entry } /> }
            { isUserType('power') && <EntryMetadata className={ staticOrLink } entry={ entry } /> }
            <EntryContentText showSummary={ true } entry={ entry } />
        </div>
    )
}

export default EntryThumbnail
